
function Footer(): HTMLElement  {
   return div("© 2025 Sigment. Built with love for developers");
}


export default Footer;